<template>
  <div class="video-clip-list-group">
    <div class="video-clip-options" v-show="isCheck">
      <a-button
        type="primary"
        @click="handleIconClick('icon-ziyuan61', 'check')"
      >
        <a-icon theme="filled" type="copy" />
        复制
      </a-button>
      <a-button
        type="danger"
        @click="handleIconClick('icon-ziyuan80', 'check')"
      >
        <a-icon theme="filled" type="delete" />
        删除
      </a-button>
      <a-button @click="handleGroupClick">取消</a-button>
    </div>
    <menu-button
      class="video-clip-addbtn"
      @click="showSubVideoClipList"
      v-show="!isCheck"
    >
      <span class="icon iconfont icon-add-fill video-add"></span>
      添加片段
    </menu-button>
    <div class="video-clip-list" @click.self="handleGroupClick">
      <fragment-item
        v-for="(videoItem, i) in clipList"
        @selectItem="onChange(i)"
        @checkItem="checkItem(i)"
        @iconClick="handleIconClick($event, 'click')"
        :active="i === activeFragmentIndex"
        :isCheck="isCheck"
        :checkActive="checkList.indexOf(i) != -1"
        :videoItem="videoItem"
        :key="videoItem.id"
        :last="i === clipList.length - 1"
        :transitionActive="i === activeTransitionIndex"
        @transitionClick="handleTransitionClick(i)"
        @before="handleReorder(i)"
        @after="handleReorder(i + 1)"
        :style="fragmentStyle(i)"
        :label="getFragmentName(i + 1)"
      />
    </div>

    <a-modal
      title="操作提醒"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确认"
    >
      <p>删除后不可恢复，确认删除选中的片段？</p>
    </a-modal>
  </div>
</template>

<script>
import { message } from "ant-design-vue";
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import FragmentItem from './FragmentItem';

import MenuButton from '../base/MenuButton';
// import { fakeFunction } from "../../utils/util";

export default {
  name: "VideoClipList",
  data: function () {
    return {
      // iconButtonList: [
      //   'icon-ziyuan61',
      //   'icon-ziyuan80'
      // ],
      visible: false,
      checkList: [],
      isCheck: false
    }
  },
  components: {
    'fragment-item': FragmentItem,
    'menu-button': MenuButton
  },
  methods: {
    ...mapMutations(['handleShowSubVideoClipList', 'handleShowTransitionList', 'handleActiveTransitionIndex']),
    ...mapActions(['removeFragment', 'copyFragment']),
    showSubVideoClipList() {
      this.handleShowSubVideoClipList(true);
    },
    onChange: function (event) {
      this.isCheck = false;
      this.checkList = [];
      this.$store.commit('handleActiveFragmentIndex', event);
    },
    // getTitle(icon) {
    //   return {
    //     'icon-ziyuan61': '复制',
    //     'icon-ziyuan80': '删除'
    //   }[icon]
    // },
    handleGroupClick() {
      this.isCheck = false;
      this.checkList = [];
    },
    checkItem(checkIndex) {
      if (!this.isCheck) {
        if (this.$store.state.activeFragmentIndex == checkIndex) {
          this.checkList = [checkIndex]
        } else {
          this.checkList = [this.$store.state.activeFragmentIndex, checkIndex]
        }
        this.isCheck = true;
      } else {
        let isCheck = false
        this.checkList.forEach((item, index) => {
          if (item == checkIndex) {
            isCheck = index
          }
        })
        if (isCheck !== false) {
          this.checkList.splice(isCheck, 1)
        } else {
          this.checkList.push(checkIndex)
        }
      }
      // 降序便于批量复制删除
      this.checkList.sort((a, b) => {
        return b - a;
      });

      if (!this.checkList.length) {
        this.isCheck = false;
      }
    },
    handleOk: function () {
      this.visible = false;
      if (this.isCheck) {
        this.checkList.forEach(item => {
          this.removeFragment(item);
        })
        this.isCheck = false;
        this.checkList = [];
      } else {
        this.removeFragment();
      }
    },
    handleCancel: function () {
      this.visible = false
    },
    handleIconClick: function (icon, type) {
      let checkList = this.checkList
      const fnMap = {
        'icon-qiehuan': () => {
          // message.info('进入片段更换模式');
          this.handleShowSubVideoClipList('replace');
        },
        'icon-ziyuan61': () => {
          if (type == 'click') {
            this.copyFragment();
          } else if (type == 'check') {
            if (!checkList.length) {
              message.error('请选择需要复制的片段');
              return;
            } else {
              checkList.forEach(item => {
                this.copyFragment(item);
              })
              this.isCheck = false;
              this.checkList = [];
            }
          }
        },
        'icon-ziyuan80': () => {
          if (type == 'click' && this.clipList.length <= 1) {
            message.error('最后一个片段不允许删除');
            return;
          } else if (type == 'check') {
            if (this.clipList.length <= 1) {
              message.error('最后一个片段不允许删除');
              return;
            } else if (!checkList.length) {
              message.error('请选择需要删除的片段');
              return;
            } else if (checkList.length == this.clipList.length) {
              message.error('不允许删除全部片段');
              return;
            }
          }
          this.visible = true
        },
      };
      fnMap[icon]()
    },
    handleTransitionClick: function (event) {
      this.handleShowTransitionList(true);
      this.handleActiveTransitionIndex(event)
    },
    getFragmentName(i) {
      return i < 10 ? '0' + i : i
    },
    handleReorder(i) {
      this.nextOrder = i;
    },
    fragmentStyle(i) {
      if (this.fragmentReordering && this.nextOrder !== null) {
        if (i !== this.activeFragmentIndex) { // style is handled in the active fragment's own component
          if (this.activeFragmentIndex < this.nextOrder) {
            if (i > this.activeFragmentIndex && i < this.nextOrder) {
              return {
                transform: 'translateY(-206px)'
              };
            }
          } else if (this.activeFragmentIndex > this.nextOrder) {
            if (i < this.activeFragmentIndex && i >= this.nextOrder) {
              return {
                transform: 'translateY(206px)'
              };
            }
          }
        }
      }
      return {};
    }
  },
  computed: {
    ...mapState([
      'activeTransitionIndex',
      'showTransitionList',
      'effects',
      'screenRatio',
      'activeFragmentIndex',
      'fragmentReordering'
    ]),
    ...mapGetters(['activeFragment']),
    currentVideo() {
      return this.activeFragment
    },
    clipList() {
      return this.$store.state.fragments;
    },
    nextOrder: {
      get() {
        return this.$store.state.nextFragmentOrder;
      },
      set(value) {
        this.$store.commit('handleNextFragmentOrder', value);
      }
    }
  },
  watch: {
    activeFragmentIndex() {
      this.handleShowSubVideoClipList(false);
    }
  },
  beforeDestroy() {
    this.handleShowSubVideoClipList(false);
  }
}
</script>

<style scoped>
.video-clip-list-group {
  position: relative;
  height: 100%;
  overflow-y: auto;
}

.video-clip-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;
  width: 100%;
  height: calc(100% - 70px);
  overflow-y: scroll;
  margin: 0 auto;
  position: relative;
  padding-left: 15px;
  margin-top: 70px;
}

.video-clip-addbtn {
  width: 224px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  margin: 18px auto 12px;
}

.video-clip-options {
  width: 100%;
  height: 58px;
  position: absolute;
  left: 0;
  top: 0;
  margin-bottom: 12px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 18px 24px 12px;
}
.video-clip-options .ant-btn {
  width: 68px;
  padding: 0;
}
/* 
.video-clip-options .icon-close{
  position: absolute;
  top: 0;
  right: 5px;
  color: #000;
  font-size: 22px;
  cursor: pointer;
}

.icon {
  font-size: 12px;
  color: #ffffff;
  transform: scale(0.92);
}
.video-clip-op{
  cursor: pointer;
}
.video-clip-op:hover{
  color: #007eff;
}
.video-clip-op:hover .video-clip-button{
  background-color: #007eff;
}

.video-clip-button {
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  justify-content: center;
  margin-right: 10px;
  outline: none;
  border: 0;
} */

.video-add {
  font-size: 20px;
  margin-right: 5px;
}
</style>

<style>
.video-clip-list-group .ant-time-picker-input {
  margin: 0;
  padding: 0;
  height: 25px;
  padding-left: 5px;
}

.video-clip-list-group .ant-time-picker {
  width: 80px;
  position: relative;
  z-index: 2;
}

.video-clip-list-group .ant-time-picker-icon,
.video-clip-list-group .ant-time-picker-clear {
  right: 5px;
}

.video-clip-list-group .ant-time-picker-clear {
  display: none;
}
</style>
